<template>
  <div class="tva-breadcrumb">
    <div
      :class="[
        'tva-breadcrumb-item',
        { active: listItem === content.length - 1 }
      ]"
      v-for="(item, listItem) in content"
      :key="listItem"
    >
      {{ item }}
    </div>
  </div>
</template>
<script>
export default {
  props: ["content"]
};
</script>
<style lang="scss" scoped>
.tva-breadcrumb {
  display: flex;
  margin: 1em 0;
  .tva-breadcrumb-item {
    position: relative;
    cursor: pointer;
    user-select: none;
    &:not(:last-child) {
      margin-right: 2em;
      &::after {
        position: absolute;
        bottom: 1px;
        right: -1em;
        content: "/";
      }
    }
  }
}
</style>
